import Crud from '../views/Color/Crud'
import Entity from '../views/Color/Add'

let routes = {
    path: '/color',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/colors/add',
            name: 'Newcolor',
            component: Entity,
            meta: {
                pageTitle: 'Cor',
                access_nivel: ['6'],
                breadcrumb: [
                    {
                        text: 'Adicionar Cor',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/colors/edit/:id?',
            name: 'Editcolor',
            component: Entity,
            meta: {
                pageTitle: 'Cor',
                access_nivel: ['6'],
                breadcrumb: [
                    {
                        text: 'Editar Cor',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/colors',
            name: 'list-colors',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Cores',
                access_nivel: ['6'],
                breadcrumb: [
                    {
                        text: 'Cors',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
